
namespace TabAurous.Stock {
/*    export class ProductPerformanceOptions {
        items: StockReportRow[];
    }

    @Serenity.Decorators.responsive()
    export class ProductPerformancePanel extends Serenity.TemplatedPanel<ProductPerformanceOptions> {
        constructor(container: JQuery, opt: ProductPerformanceOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var purchase = [0];
            var sales = [0];
            var profit = [0];
            code.pop();
            purchase.pop();
            profit.pop();
            sales.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                for (var j = 0; j < code.length; j++) {
                    if (data[i].CategoryName.match(code[j])) {
                        checkexists = true;
                        purchase[j] += data[i].PurchaseTotal;
                        sales[j] += data[i].SalesTotal;
                        profit[j] += data[i].Profit;
                    }
                }
                if (!checkexists) {
                    code.push(data[i].CategoryName);
                    sales.push(data[i].SalesTotal);
                    purchase.push(data[i].PurchaseTotal);
                    profit.push(data[i].Profit);
                }
            }
            var options = {
                series: [{
                    name: 'Purchase',
                    type: 'column',
                    data: purchase
                }, {
                    name: 'Sales',
                    type: 'column',
                    data: sales
                }, {
                    name: 'Profit',
                    type: 'line',
                    data: profit
                }],
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    width: [1, 1, 4]
                },
                title: {
                    
                    align: 'left',
                    offsetX: 110
                },
                xaxis: {
                    categories: code,
                },
                yaxis: [
                    {
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#008FFB'
                        },
                        labels: {
                            style: {
                                colors: '#008FFB',
                            }
                        },
                        title: {
                            text: "Purchase (thousand)",
                            style: {
                                color: '#008FFB',
                            }
                        },
                        tooltip: {
                            enabled: true
                        }
                    },
                    {
                        seriesName: 'Sales',
                        opposite: true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#00E396'
                        },
                        labels: {
                            style: {
                                colors: '#00E396',
                            }
                        },
                        title: {
                            text: "Sales(thousand crores)",
                            style: {
                                color: '#00E396',
                            }
                        },
                    },
                    {
                        seriesName: 'Profit',
                        opposite: true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#FEB019'
                        },
                        labels: {
                            style: {
                                colors: '#FEB019',
                            },
                        },
                        title: {
                            text: "Profit (thousand crores)",
                            style: {
                                color: '#FEB019',
                            }
                        }
                    },
                ],
                tooltip: {
                    fixed: {
                        enabled: true,
                        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                        offsetY: 30,
                        offsetX: 60
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 40
                }
            };
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }
*/
   
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class StockAgingGrid extends Serenity.EntityGrid<StockReportRow, any> {
        protected getColumnsKey() { return 'Stock.StockReport'; } 
        protected getIdProperty() { return StockReportRow.idProperty; }
        protected getInsertPermission() { return StockReportRow.insertPermission; }
        protected getLocalTextPrefix() { return StockReportRow.localTextPrefix; }
        protected getService() { return StockReportService.baseUrl; }
        protected createQuickSearchInput() { }
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }
        protected getButtons() { return []; }
        //onViewProcessData(response: Serenity.ListResponse<StockReportRow>) {

        //    if (!this.chartContainer) {
        //        this.chartContainer = $("<div style='padding: 20px 0' />");
        //        this.chartContainer.insertBefore(this.element.find(".grid-container"));
        //    }

        //    if (this.chartPanel) {
        //        this.chartPanel.destroy();
        //    }

        //    this.chartPanel = new ProductPerformancePanel(this.chartContainer, { items: response.Entities });

           


        //    return response;
        //}

    }
}